<template>
    <div class="home-wrap">
        <div class="slider-wrapper">
            <Slider :slides="slides"/>
        </div>
        <!--
        <div class="content">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa dolorem porro repellat maiores quaerat quod fugit aspernatur omnis vel praesentium! Necessitatibus, magnam dolor sint ratione consectetur corrupti quae aperiam deleniti temporibus, velit delectus eius aut. Quia tenetur sed voluptate eaque in doloremque modi eos accusantium ullam amet? Quidem, impedit iste fuga sit placeat neque ipsam incidunt repellendus! Nihil facere consectetur iure fugiat ad unde obcaecati sint, eveniet nostrum. Deleniti, dolore nisi qui voluptatibus quidem blanditiis quibusdam facere ea officiis tenetur repellat quia minus corporis voluptate eius sit quam quos ullam obcaecati voluptates beatae ipsum! Asperiores recusandae minima illum modi exercitationem dolores, tempore reiciendis facilis, accusamus, a porro ratione repellat neque veritatis? Pariatur assumenda exercitationem vitae adipisci iste, ex officia omnis impedit officiis iusto sit natus facilis architecto veritatis alias veniam minima amet quod, consequatur quasi. Aliquam, saepe deleniti enim voluptates iste voluptatum quia asperiores quo odio. Quaerat nemo ab ipsam aperiam officia sapiente? Adipisci consequatur laboriosam omnis dignissimos veniam eveniet dolor ex molestias iusto pariatur, magni, harum nulla consequuntur dicta officia ab qui voluptates tenetur neque, error culpa. Alias temporibus quos, ad repellat saepe ab ratione consectetur nisi quo odit, omnis laboriosam quam officiis dolore delectus laudantium. Velit autem tempore, est ducimus voluptas ex eius iste. Dicta consequatur cupiditate dolor magnam tempora perspiciatis maxime at distinctio error laboriosam temporibus repellendus facilis voluptatem facere totam ab quae voluptas molestiae eligendi reprehenderit, tenetur quidem. Minima optio deserunt at placeat corrupti necessitatibus, ducimus porro! Repellat eligendi quam at expedita nulla corporis accusantium nisi ut laudantium ex, rem eius ullam consequuntur ratione. Enim labore possimus a, sunt ratione ad, nostrum eveniet vitae provident consequatur, soluta ea? Sed rerum velit, voluptates expedita libero fugiat aut sunt quaerat molestiae dolorum accusamus eveniet autem! Atque voluptates id similique at totam. Odit est quisquam impedit, voluptate dignissimos reiciendis nihil consequuntur placeat neque quos temporibus explicabo aut hic fugit. Velit officia ipsa sit delectus! Vel at consectetur consequuntur? Recusandae praesentium quasi eius odit repellendus quas nihil perspiciatis tenetur quod minima obcaecati iure suscipit ut tempora delectus, deserunt laboriosam dolore ratione ex. Reiciendis adipisci doloremque voluptatum porro recusandae sint nihil! Nihil esse architecto vel error incidunt ullam ad facere id quibusdam dicta quod, dolorem soluta recusandae vitae sapiente blanditiis quam dignissimos provident dolor exercitationem ex sed velit? Dolor, deleniti velit earum, quasi similique quam quia quis quaerat eaque commodi corrupti magni totam molestiae, illum nobis suscipit officiis sequi sint. Sed in est facilis dolore voluptate ea culpa et cumque labore obcaecati, libero corporis amet dignissimos nobis quos minima dicta, consequatur, ex odio saepe corrupti magnam. Et ipsam similique vitae, laudantium, est, eaque dolores consequuntur necessitatibus excepturi nobis voluptatibus expedita sint consectetur minima aliquid. A sunt dignissimos natus corrupti totam! Labore eius, non nisi obcaecati temporibus aliquam laboriosam quod id repellat laudantium vero voluptatem atque! Nostrum assumenda enim illum numquam distinctio provident necessitatibus repudiandae laudantium minus iusto, facere error aut alias. Accusantium saepe molestias quia laboriosam? Vitae minus illum voluptatibus voluptas voluptate pariatur suscipit, id laborum nam quis aliquam. Sapiente, hic.
        </div>
        -->
    </div>
</template>






<script>

import Slider from './Slider'


export default {

    name: 'Home',

    components: {
        Slider
    },

    data() {
        return {


            slides: [

                {
                    hasImage: false,
                    hasText: true,
                    hasAction: false,
                    scrollDown: false,

                    background: "https://tabula-agency.co.za/slider/SlateBGLargeNew.jpg",

                    heading: '<em>tabula rasa</em>',
                    text1: 'solutions derived from a clean slate',
                    text2: 'an absence of preconceived ideas or predetermined goals',

                    action: '',

                    image: '',
                    alt: ''
                },
                
                {
                    hasImage: false,
                    hasText: true,
                    hasAction: false,
                    scrollDown: false,

                    background: "https://tabula-agency.co.za/slider/SlateBGLargeNew.jpg",

                    heading: 'creative, bold brand identity',
                    text1: 'specialising in educational marketing',
                    text2: '',

                    action: '',

                    image: '',
                    alt: ''
                },
                
            ],


        }
    },




}
</script>





<style>

.home-wrap {
    
}




</style>